/* eslint-disable no-console */

import { register } from 'register-service-worker'

let refreshing = false;

// Listen for controller change - auto-refresh when service worker updates
navigator.serviceWorker.addEventListener('controllerchange', () => {
  if (refreshing) return;
  refreshing = true;
  console.log('Service Worker updated. Auto-refreshing to latest version...');
  window.location.reload();
});

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.');
      // Check for updates periodically (every 60 minutes)
      setInterval(() => {
        navigator.serviceWorker.getRegistrations().then(registrations => {
          registrations.forEach(registration => {
            registration.update().catch(error => {
              console.error('Service worker update check failed:', error);
            });
          });
        });
      }, 60 * 1000);
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content detected. Will auto-refresh in 2 seconds...');
      // Auto-refresh after 2 seconds
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    },
    updated () {
      console.log('New content is available and auto-refresh triggered.')
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
